export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10885.ecf79741.jpg";